import { useEffect, useState } from "react";
import format from "date-fns/format";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { useAuth } from "common/hooks/useAuth";

const useFormattedTimer = ({ value }) => {
    const [timeLeft, setTimeLeft] = useState();
    
    useEffect(() => {
        const timer = setTimeout(() => {
            if (value) {
                setTimeLeft(format(Math.abs(value - Date.now()), "mm:ss"));
            } else {
                setTimeLeft("expired");
            }
        }, 1000);
        // Clear timeout if the component is unmounted
        return () => clearTimeout(timer);
    }, [value, timeLeft]);
    
    return {
        timeLeft
    };
};

export const LastInteractedObserver = function() {
    const last_interacted = useSelector((state) => state.authentication.last_interacted);
    const { timeLeft } = useFormattedTimer({ value: last_interacted });
    
    return (
        <LastInteractionObserverWrapper>
            <div>Last interaction</div>
            <div>{timeLeft}</div>
        </LastInteractionObserverWrapper>
    );
};

export const TokenObserver = function() {
    const { expiresAt } = useAuth();
    const { timeLeft } = useFormattedTimer({ value: expiresAt });
    
    return (
        <TokenObserverWrapper>
            <div>Token expires in</div>
            <div>{timeLeft}</div>
        </TokenObserverWrapper>
    );
};

const TokenObserverWrapper = styled.div`
    z-index: 1000;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #f67762;
    color: #fff;
    padding: 5px;
    font-size: 11px;
    text-align: right;
    height: 40px;
`;

const LastInteractionObserverWrapper = styled(TokenObserverWrapper)`
    right: 91px;
    background: #4eaae1;
`;
